import { render } from "./modal-error-not-allow-edit.vue?vue&type=template&id=5d58078a&ts=true"
import script from "./modal-error-not-allow-edit.vue?vue&type=script&lang=ts"
export * from "./modal-error-not-allow-edit.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__